module.exports = __webpack_public_path__ + "media/images/img06-9bba1f472bd8d9572d2dbaa88df098a6.png";